export default __webpack_public_path__ + "static/labelmap-assist-1e1e40bc54139f34ba4d7c682d13661a.gif";